// Roles whose CRM data is restricted to a single hotspot (see CrmUserHotspotMapping on the backend).
// These users get trip counts and a trip list only - individual ride details are not exposed to them.
// The backend enforces this too: get_ride_by_id does not whitelist these roles, so the detail api
// returns 403. Hiding the entry points here keeps them from hitting a dead end in the UI.
export const HOTSPOT_SCOPED_ROLES = ["hotspot_viewer"];

export const isHotspotScopedRole = (role) => HOTSPOT_SCOPED_ROLES.includes(role);
